import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faq } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section id="questions" aria-labelledby="faq-title" className="bg-white py-12 md:py-20" data-id="element-73" data-mp="1gitws6qmn0ks">
      <div className="mx-auto max-w-[820px] px-5 md:px-8" data-id="element-74" data-mp="248oaeqirst63">
        <SectionHeading id="faq-title" eyebrow={faq.eyebrow} title={faq.title} sub={faq.sub} data-id="element-75" data-mp="24bk585zbn1qb" />

        <ul className="mt-8 space-y-2.5 md:mt-10" data-id="element-76" data-mp="28cvvmdq0rqzk">
          {faq.items.map((item, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          const buttonId = `faq-button-${i}`;
          return <li key={item.q} className={`rounded-xl border bg-white transition-colors duration-150 ease-out ${isOpen ? 'border-brand' : 'border-hair'}`} data-id="element-77" data-mp="2n7sh3smuaaul" data-mpi={i}>
                <h3 data-id="element-78" data-mp="14wby6yf415ze">
                  <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex min-h-[60px] w-full items-center justify-between gap-4 rounded-xl px-4 py-4 text-left text-[16px] font-semibold text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand md:px-6 md:text-[17px]" data-id="element-79" data-mp="14vtq94j353bn">
                    {item.q}
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out ${isOpen ? 'bg-brand text-white' : 'bg-mist text-brand'}`} data-id="element-80" data-mp="1xiworwnrhe1w">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} strokeWidth={2.5} aria-hidden="true" data-id="element-81" data-mp="37ron2bvvjrb" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-82" data-mp="286rdj9yw0bu3">
                  {isOpen && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-83" data-mp="2c8megdcwon7c">
                      <p className="px-4 pb-5 text-[16px] leading-relaxed text-ink/75 md:px-6" data-id="element-84" data-mp="2vyoeu74pnlgy">{item.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}